// extracted by mini-css-extract-plugin
export default {"text":"ForgotPassword_text__Bsfcr","password":"ForgotPassword_password__vg--2","btn":"ForgotPassword_btn__XLIfB","logo":"ForgotPassword_logo__C3vHD"};